// import React, { useEffect, useRef, useState, useCallback } from "react";
// import { createPortal } from "react-dom";
// import { jsPDF } from "jspdf";
// import {
//   RiCloseLine,
//   RiDownloadLine,
//   RiFileTextLine,
//   RiArrowLeftSLine,
//   RiArrowRightSLine,
//   RiZoomInLine,
//   RiZoomOutLine,
//   RiNewspaperLine,
//   RiCalendarLine,
//   RiHashtag,
// } from "react-icons/ri";
// import { AiOutlineLoading3Quarters } from "react-icons/ai";

// // ─── formatting helpers ────────────────────────────────────────────────────────

// const fmt = (n) =>
//   Number(n || 0).toLocaleString("en-IN", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   });

// function formatDate(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr);
//   if (isNaN(d)) return String(dateStr);
//   return d.toLocaleDateString("en-IN", {
//     day: "2-digit",
//     month: "2-digit",
//     year: "numeric",
//   });
// }

// // ─── PDF constants (must match generateQuotationThreePDF layout) ──────────────

// const IMG_W_PX = 700;
// const IMG_H_PX = 990;
// const PAGE_W_MM = 210;
// const PAGE_H_MM = 297;
// const scaleX = PAGE_W_MM / IMG_W_PX;
// const scaleY = PAGE_H_MM / IMG_H_PX;
// const px = (x) => x * scaleX;
// const py = (y) => y * scaleY;

// const ROWS_PER_PAGE = 21;
// const TABLE_START_Y = 295;
// const TABLE_CONT_Y = 295;
// const ROW_H_PX = 18;

// const COL = {
//   slNo: 37,
//   newspaper: 150,
//   edition: 340,
//   rate: 440,
//   size: 500,
//   amount: 600,
// };

// // ─── buildQuotationThreeDocs ───────────────────────────────────────────────────
// // Mirrors buildQuotationOneDocs pattern.
// // Returns [{ doc, dataUrl, label }] — one entry per PDF page.

// function buildQuotationThreeDocs(quotationData, bgBase64) {
//   const {
//     quotationNumber = "",
//     date = "",
//     client = {},
//     personName = "",
//     mediaRateCardItems = [],
//     amountInWords = "",
//     selectedQuery = null,
//     advertisingType = "",
//   } = quotationData;

//   const clientName = client.bankName || client.name || "";

//   const dataUri =
//     typeof bgBase64 === "string" && bgBase64.startsWith("data:")
//       ? bgBase64
//       : `data:image/png;base64,${bgBase64}`;

//   function makeDoc() {
//     return new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
//   }

//   function addBackground(doc) {
//     doc.addImage(dataUri, "PNG", 0, 0, PAGE_W_MM, PAGE_H_MM);
//   }

//   function makeDrawText(doc) {
//     return function drawText(str, imgX, imgY, opts = {}) {
//       if (str === undefined || str === null || str === "") return;
//       const {
//         fontSize = 9,
//         fontStyle = "normal",
//         color = [20, 20, 20],
//         align = "left",
//         maxWidth,
//       } = opts;
//       if (Array.isArray(color)) doc.setTextColor(color[0], color[1], color[2]);
//       doc.setFontSize(fontSize);
//       doc.setFont("helvetica", fontStyle);
//       if (maxWidth) {
//         const lines = doc.splitTextToSize(String(str), px(maxWidth));
//         doc.text(lines[0] ?? "", px(imgX), py(imgY), { align });
//       } else {
//         doc.text(String(str), px(imgX), py(imgY), { align });
//       }
//     };
//   }

//   function drawRow(drawText, item, rowIndex, tableStartY) {
//     const rateCard = item.mediaRateCard || {};
//     const ry = tableStartY + rowIndex * ROW_H_PX;
//     const newspaper = rateCard.media?.organisation || "";
//     const edition = rateCard.edition || "";
//     const rate = rateCard.ratePerSquareMeter ?? item.rate ?? "";
//     const h = item.height != null ? Number(item.height) : null;
//     const w = item.width != null ? Number(item.width) : null;
//     const sizeStr = h != null && w != null ? `${w}×${h} cm` : "";
//     const amount = item.amount ?? 0;

//     drawText(newspaper, COL.newspaper, ry, { fontSize: 8, maxWidth: 145 });
//     drawText(edition, COL.edition, ry, { fontSize: 8, maxWidth: 90 });
//     drawText(rate !== "" ? fmt(rate) : "", COL.rate, ry, {
//       fontSize: 8,
//       align: "right",
//       maxWidth: 68,
//     });
//     drawText(sizeStr, COL.size, ry, {
//       fontSize: 8,
//       align: "center",
//       maxWidth: 90,
//     });
//     drawText(fmt(amount), COL.amount, ry, {
//       fontSize: 8,
//       align: "right",
//       maxWidth: 80,
//     });
//   }

//   function drawHeader(drawText) {
//     drawText(formatDate(date), 108, 78, { fontSize: 9 });
//     drawText(quotationNumber, 556, 126, {
//       fontSize: 10,
//       align: "left",
//       fontStyle: "bold",
//       maxWidth: 120,
//     });
//     drawText("To", 72, 110, { fontSize: 9, maxWidth: 260 });
//     drawText(personName, 81, 126, { fontSize: 9, maxWidth: 260 });
//     drawText(clientName || "", 81, 140, { fontSize: 9, maxWidth: 260 });
//     drawText([client.address].filter(Boolean).join("   "), 81, 154, {
//       fontSize: 9,
//       maxWidth: 260,
//     });
//     drawText(advertisingType, 300, 187, { fontSize: 9, maxWidth: 330 });
//   }

//   function drawFooter(doc, drawText, tableStartY) {
//     const TOTAL_Y = tableStartY + 19.3 * ROW_H_PX + 19;
//     doc.setFontSize(9);
//     doc.setFont("helvetica", "normal");
//     doc.setTextColor(20, 20, 20);
//     const wordLines = doc.splitTextToSize(amountInWords || "", px(400));
//     doc.text(wordLines[0] ?? "", px(40), py(TOTAL_Y + 18));
//     if (selectedQuery?.contactPersonName) {
//       drawText(selectedQuery.contactPersonName, 90, TOTAL_Y + 60, {
//         fontSize: 9,
//         color: [200, 0, 0],
//         fontStyle: "bold",
//         maxWidth: 200,
//       });
//     }
//     if (selectedQuery?.phone) {
//       drawText(selectedQuery.phone, 300, TOTAL_Y + 60, {
//         fontSize: 8,
//         color: [200, 0, 0],
//         fontStyle: "bold",
//         maxWidth: 200,
//       });
//     }
//   }

//   const docs = [];
//   const firstBatch = mediaRateCardItems.slice(0, ROWS_PER_PAGE);
//   const remaining = mediaRateCardItems.slice(ROWS_PER_PAGE);

//   // ── Page 1 ──
//   const doc1 = makeDoc();
//   const drawText1 = makeDrawText(doc1);
//   addBackground(doc1);
//   drawHeader(drawText1);
//   firstBatch.forEach((item, idx) =>
//     drawRow(drawText1, item, idx, TABLE_START_Y),
//   );
//   if (remaining.length === 0) {
//     drawFooter(doc1, drawText1, TABLE_START_Y);
//   }
//   docs.push({
//     doc: doc1,
//     dataUrl: doc1.output("datauristring"),
//     label: "Page 1",
//   });

//   // ── Continuation pages ──
//   const chunks = [];
//   for (let i = 0; i < remaining.length; i += ROWS_PER_PAGE) {
//     chunks.push(remaining.slice(i, i + ROWS_PER_PAGE));
//   }

//   chunks.forEach((batch, chunkIdx) => {
//     const docN = makeDoc();
//     const drawTextN = makeDrawText(docN);
//     addBackground(docN);
//     drawTextN(formatDate(date), 108, 78, { fontSize: 9 });
//     drawTextN(quotationNumber, 556, 126, {
//       fontSize: 10,
//       align: "left",
//       fontStyle: "bold",
//       maxWidth: 120,
//     });
//     batch.forEach((item, idx) => drawRow(drawTextN, item, idx, TABLE_CONT_Y));
//     if (chunkIdx === chunks.length - 1) {
//       drawFooter(docN, drawTextN, TABLE_CONT_Y);
//     }
//     docs.push({
//       doc: docN,
//       dataUrl: docN.output("datauristring"),
//       label: `Page ${chunkIdx + 2}`,
//     });
//   });

//   return docs;
// }

// // ─── QuotationViewModalThree ───────────────────────────────────────────────────

// export default function QuotationViewModalThree({
//   open,
//   quotationData,
//   onClose,
//   bgBase64,
// }) {
//   const [pages, setPages] = useState([]);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [zoom, setZoom] = useState(1);
//   const [generating, setGenerating] = useState(true);
//   const containerRef = useRef(null);

//   useEffect(() => {
//     if (!open || !quotationData || !bgBase64) return;
//     setGenerating(true);
//     try {
//       const built = buildQuotationThreeDocs(quotationData, bgBase64);
//       setPages(built);
//       setCurrentPage(0);
//     } catch (err) {
//       console.error("QuotationViewModalThree build error:", err);
//     } finally {
//       setGenerating(false);
//     }
//   }, [open, quotationData, bgBase64]);

//   const handleDownloadCurrent = useCallback(() => {
//     if (!pages[currentPage]) return;
//     const { doc } = pages[currentPage];
//     const fname = `Quotation_${(
//       quotationData?.quotationNumber || "draft"
//     ).replace(/\//g, "-")}_p${currentPage + 1}.pdf`;
//     doc.save(fname);
//   }, [pages, currentPage, quotationData]);

//   const handleDownloadAll = useCallback(() => {
//     if (pages.length === 1) {
//       handleDownloadCurrent();
//       return;
//     }
//     pages.forEach(({ doc }, idx) => {
//       const fname = `Quotation_${(
//         quotationData?.quotationNumber || "draft"
//       ).replace(/\//g, "-")}_p${idx + 1}.pdf`;
//       doc.save(fname);
//     });
//   }, [pages, quotationData, handleDownloadCurrent]);

//   const handleZoomIn = () => setZoom((z) => Math.min(z + 0.2, 2.5));
//   const handleZoomOut = () => setZoom((z) => Math.max(z - 0.2, 0.3));

//   if (!open) return null;

//   const totalPages = pages.length;
//   const current = pages[currentPage];
//   const clientName =
//     quotationData?.client?.bankName || quotationData?.client?.name || "—";
//   const itemCount = quotationData?.mediaRateCardItems?.length || 0;

//   return createPortal(
//     <div
//       className="fixed inset-0 z-50 flex flex-col"
//       style={{ background: "rgba(8,15,35,0.95)" }}
//     >
//       {/* ── Top Bar ── */}
//       <div
//         className="flex items-center justify-between px-5 py-3 flex-shrink-0"
//         style={{
//           background: "linear-gradient(90deg,#0f1c3f 0%,#1a2f5e 100%)",
//           borderBottom: "1px solid rgba(99,140,220,0.18)",
//         }}
//       >
//         {/* Left: quotation info */}
//         <div className="flex items-center gap-3 min-w-0">
//           <div
//             className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
//             style={{
//               background: "rgba(59,108,230,0.25)",
//               border: "1px solid rgba(59,108,230,0.4)",
//             }}
//           >
//             <RiFileTextLine
//               style={{ width: 18, height: 18, color: "#93c5fd" }}
//             />
//           </div>
//           <div className="min-w-0">
//             <p className="text-xs font-bold text-blue-200 font-mono tracking-wider truncate flex items-center gap-1.5">
//               <RiHashtag style={{ width: 11, height: 11 }} />
//               {quotationData?.quotationNumber || "—"}
//             </p>
//             <p className="text-[10px] text-blue-400 truncate flex items-center gap-1.5">
//               <span>{clientName}</span>
//               {quotationData?.date && (
//                 <>
//                   <span className="opacity-40">·</span>
//                   <RiCalendarLine style={{ width: 10, height: 10 }} />
//                   <span>{formatDate(quotationData.date)}</span>
//                 </>
//               )}
//               {itemCount > 0 && (
//                 <>
//                   <span className="opacity-40">·</span>
//                   <RiNewspaperLine style={{ width: 10, height: 10 }} />
//                   <span>
//                     {itemCount} item{itemCount !== 1 ? "s" : ""}
//                   </span>
//                 </>
//               )}
//             </p>
//           </div>
//         </div>

//         {/* Center: page navigation */}
//         {totalPages > 1 && (
//           <div className="flex items-center gap-2">
//             <button
//               onClick={() => setCurrentPage((p) => Math.max(0, p - 1))}
//               disabled={currentPage === 0}
//               className="w-8 h-8 rounded-lg flex items-center justify-center transition disabled:opacity-30"
//               style={{
//                 background: "rgba(59,108,230,0.18)",
//                 border: "1px solid rgba(59,108,230,0.3)",
//               }}
//             >
//               <RiArrowLeftSLine
//                 style={{ width: 16, height: 16, color: "#93c5fd" }}
//               />
//             </button>
//             <span
//               className="text-xs font-semibold text-blue-200 px-3 py-1 rounded-md"
//               style={{ background: "rgba(59,108,230,0.15)" }}
//             >
//               Page {currentPage + 1} / {totalPages}
//             </span>
//             <button
//               onClick={() =>
//                 setCurrentPage((p) => Math.min(totalPages - 1, p + 1))
//               }
//               disabled={currentPage === totalPages - 1}
//               className="w-8 h-8 rounded-lg flex items-center justify-center transition disabled:opacity-30"
//               style={{
//                 background: "rgba(59,108,230,0.18)",
//                 border: "1px solid rgba(59,108,230,0.3)",
//               }}
//             >
//               <RiArrowRightSLine
//                 style={{ width: 16, height: 16, color: "#93c5fd" }}
//               />
//             </button>
//           </div>
//         )}

//         {/* Right: zoom + download + close */}
//         <div className="flex items-center gap-2 flex-shrink-0">
//           {/* Zoom controls */}
//           <div
//             className="flex items-center gap-1 px-2 py-1 rounded-lg"
//             style={{
//               background: "rgba(59,108,230,0.12)",
//               border: "1px solid rgba(59,108,230,0.22)",
//             }}
//           >
//             <button
//               onClick={handleZoomOut}
//               title="Zoom Out"
//               className="w-7 h-7 flex items-center justify-center rounded transition"
//               style={{ color: "#93c5fd" }}
//             >
//               <RiZoomOutLine style={{ width: 15, height: 15 }} />
//             </button>
//             <span className="text-[11px] font-bold text-blue-200 w-10 text-center">
//               {Math.round(zoom * 100)}%
//             </span>
//             <button
//               onClick={handleZoomIn}
//               title="Zoom In"
//               className="w-7 h-7 flex items-center justify-center rounded transition"
//               style={{ color: "#93c5fd" }}
//             >
//               <RiZoomInLine style={{ width: 15, height: 15 }} />
//             </button>
//           </div>

//           {/* Download current page */}
//           <button
//             onClick={handleDownloadCurrent}
//             disabled={generating || !current}
//             className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-bold transition disabled:opacity-40"
//             style={{
//               background: "rgba(16,185,129,0.18)",
//               border: "1px solid rgba(16,185,129,0.35)",
//               color: "#6ee7b7",
//             }}
//           >
//             <RiDownloadLine style={{ width: 14, height: 14 }} />
//             {totalPages > 1 ? "This Page" : "Download"}
//           </button>

//           {/* Download all pages */}
//           {totalPages > 1 && (
//             <button
//               onClick={handleDownloadAll}
//               disabled={generating}
//               className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-bold transition disabled:opacity-40"
//               style={{
//                 background: "rgba(59,108,230,0.22)",
//                 border: "1px solid rgba(59,108,230,0.4)",
//                 color: "#93c5fd",
//               }}
//             >
//               <RiDownloadLine style={{ width: 14, height: 14 }} />
//               All ({totalPages})
//             </button>
//           )}

//           {/* Close */}
//           <button
//             onClick={onClose}
//             className="w-9 h-9 flex items-center justify-center rounded-lg transition"
//             style={{
//               background: "rgba(239,68,68,0.15)",
//               border: "1px solid rgba(239,68,68,0.3)",
//               color: "#fca5a5",
//             }}
//           >
//             <RiCloseLine style={{ width: 18, height: 18 }} />
//           </button>
//         </div>
//       </div>

//       {/* ── Page tabs (multi-page only) ── */}
//       {totalPages > 1 && !generating && (
//         <div
//           className="flex items-center gap-1 px-5 py-2 overflow-x-auto flex-shrink-0"
//           style={{
//             background: "rgba(15,28,63,0.85)",
//             borderBottom: "1px solid rgba(59,108,230,0.12)",
//           }}
//         >
//           {pages.map((p, idx) => (
//             <button
//               key={idx}
//               onClick={() => setCurrentPage(idx)}
//               className="flex-shrink-0 px-3 py-1.5 rounded-md text-xs font-semibold transition whitespace-nowrap"
//               style={
//                 currentPage === idx
//                   ? {
//                       background: "rgba(59,108,230,0.35)",
//                       border: "1px solid rgba(59,108,230,0.55)",
//                       color: "#bfdbfe",
//                     }
//                   : {
//                       background: "rgba(59,108,230,0.08)",
//                       border: "1px solid rgba(59,108,230,0.18)",
//                       color: "#6b82a8",
//                     }
//               }
//             >
//               {p.label}
//             </button>
//           ))}
//         </div>
//       )}

//       {/* ── PDF preview area ── */}
//       <div
//         ref={containerRef}
//         className="flex-1 overflow-auto flex items-start justify-center"
//         style={{
//           background:
//             "repeating-linear-gradient(45deg,#0b1427 0px,#0b1427 20px,#0c1630 20px,#0c1630 40px)",
//           padding: "32px 24px",
//         }}
//       >
//         {generating ? (
//           <div className="flex flex-col items-center gap-4 mt-24">
//             <AiOutlineLoading3Quarters
//               className="animate-spin"
//               style={{ width: 36, height: 36, color: "#60a5fa" }}
//             />
//             <p className="text-blue-300 text-sm font-medium">
//               Building PDF preview…
//             </p>
//           </div>
//         ) : !current ? (
//           <div className="flex flex-col items-center gap-3 mt-24">
//             <RiFileTextLine
//               style={{ width: 48, height: 48, color: "#1e3a6e" }}
//             />
//             <p className="text-blue-400 text-sm">No content to preview.</p>
//           </div>
//         ) : (
//           <div
//             style={{
//               transform: `scale(${zoom})`,
//               transformOrigin: "top center",
//               transition: "transform 0.2s ease",
//               boxShadow:
//                 "0 8px 64px rgba(0,0,0,0.7), 0 2px 16px rgba(59,108,230,0.18)",
//               borderRadius: 6,
//               overflow: "hidden",
//               lineHeight: 0,
//             }}
//           >
//             <iframe
//               key={current.dataUrl}
//               src={current.dataUrl}
//               title={`Quotation Preview - ${current.label}`}
//               style={{
//                 width: 760,
//                 height: 1075,
//                 border: "none",
//                 display: "block",
//                 background: "#fff",
//               }}
//             />
//           </div>
//         )}
//       </div>

//       {/* ── Footer status bar ── */}
//       {!generating && current && (
//         <div
//           className="flex items-center justify-between px-5 py-2 flex-shrink-0 text-[11px]"
//           style={{
//             background: "rgba(10,18,40,0.95)",
//             borderTop: "1px solid rgba(59,108,230,0.12)",
//             color: "#4b6896",
//           }}
//         >
//           <span>
//             Client:{" "}
//             <span className="text-blue-400 font-semibold">{clientName}</span>
//             {quotationData?.advertisingType && (
//               <>
//                 {" "}
//                 · Type:{" "}
//                 <span className="text-blue-400 font-semibold">
//                   {quotationData.advertisingType}
//                 </span>
//               </>
//             )}
//           </span>
//           <span>
//             Total:{" "}
//             <span className="text-emerald-400 font-bold text-xs">
//               ₹{fmt(quotationData?.totalAmount || 0)}
//             </span>
//           </span>
//         </div>
//       )}
//     </div>,
//     document.body,
//   );
// }

import React, { useEffect, useRef, useState, useCallback } from "react";
import { createPortal } from "react-dom";
import { jsPDF } from "jspdf";
import {
  RiCloseLine,
  RiDownloadLine,
  RiFileTextLine,
  RiArrowLeftSLine,
  RiArrowRightSLine,
  RiZoomInLine,
  RiZoomOutLine,
  RiNewspaperLine,
  RiCalendarLine,
  RiHashtag,
} from "react-icons/ri";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

// ─── formatting helpers ────────────────────────────────────────────────────────

const fmt = (n) =>
  Number(n || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

function formatDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d)) return String(dateStr);
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

// ─── PDF constants ─────────────────────────────────────────────────────────────

const IMG_W_PX = 700;
const IMG_H_PX = 990;
const PAGE_W_MM = 210;
const PAGE_H_MM = 297;
const scaleX = PAGE_W_MM / IMG_W_PX;
const scaleY = PAGE_H_MM / IMG_H_PX;
const px = (x) => x * scaleX;
const py = (y) => y * scaleY;

const ROWS_PER_PAGE = 21;
const TABLE_START_Y = 295;
const TABLE_CONT_Y = 295;
const ROW_H_PX = 18;

const COL = {
  slNo: 95,
  newspaper: 150,
  edition: 340,
  rate: 440,
  size: 500,
  amount: 600,
};

// ─── buildQuotationThreeDocs ───────────────────────────────────────────────────

function buildQuotationThreeDocs(quotationData, bgBase64) {
  const {
    quotationNumber = "",
    date = "",
    client = {},
    personName = "",
    mediaRateCardItems = [],
    amountInWords = "",
    selectedQuery = null,
    advertisingType = "",
  } = quotationData;

  const clientName = client.bankName || client.name || "";

  const dataUri =
    typeof bgBase64 === "string" && bgBase64.startsWith("data:")
      ? bgBase64
      : `data:image/png;base64,${bgBase64}`;

  function makeDoc() {
    return new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  }

  function addBackground(doc) {
    doc.addImage(dataUri, "PNG", 0, 0, PAGE_W_MM, PAGE_H_MM);
  }

  function makeDrawText(doc) {
    return function drawText(str, imgX, imgY, opts = {}) {
      if (str === undefined || str === null || str === "") return;
      const {
        fontSize = 9,
        fontStyle = "normal",
        color = [20, 20, 20],
        align = "left",
        maxWidth,
      } = opts;
      if (Array.isArray(color)) doc.setTextColor(color[0], color[1], color[2]);
      doc.setFontSize(fontSize);
      doc.setFont("helvetica", fontStyle);
      if (maxWidth) {
        const lines = doc.splitTextToSize(String(str), px(maxWidth));
        doc.text(lines[0] ?? "", px(imgX), py(imgY), { align });
      } else {
        doc.text(String(str), px(imgX), py(imgY), { align });
      }
    };
  }

  // ✅ serialNo parameter added and rendered
  function drawRow(drawText, item, rowIndex, tableStartY, serialNo) {
    const rateCard = item.mediaRateCard || {};
    const ry = tableStartY + rowIndex * ROW_H_PX;
    const newspaper = rateCard.media?.organisation || "";
    const edition = rateCard.edition || "";
    const rate = rateCard.ratePerSquareMeter ?? item.rate ?? "";
    const h = item.height != null ? Number(item.height) : null;
    const w = item.width != null ? Number(item.width) : null;
    const sizeStr = h != null && w != null ? `${w}×${h} cm` : "";
    const amount = item.amount ?? 0;

    // ✅ Serial number rendered
    drawText(String(serialNo), COL.slNo, ry, {
      fontSize: 8,
      align: "center",
    });

    drawText(newspaper, COL.newspaper, ry, { fontSize: 8, maxWidth: 145 });
    drawText(edition, COL.edition, ry, { fontSize: 8, maxWidth: 90 });
    drawText(rate !== "" ? fmt(rate) : "", COL.rate, ry, {
      fontSize: 8,
      align: "right",
      maxWidth: 68,
    });
    drawText(sizeStr, COL.size, ry, {
      fontSize: 8,
      align: "center",
      maxWidth: 90,
    });
    drawText(fmt(amount), COL.amount, ry, {
      fontSize: 8,
      align: "right",
      maxWidth: 80,
    });
  }

  function drawHeader(drawText) {
    drawText(formatDate(date), 108, 78, { fontSize: 9 });
    drawText(quotationNumber, 556, 126, {
      fontSize: 10,
      align: "left",
      fontStyle: "bold",
      maxWidth: 120,
    });
    drawText("To", 72, 110, { fontSize: 9, maxWidth: 260 });
    drawText(personName, 81, 126, { fontSize: 9, maxWidth: 260 });
    drawText(clientName || "", 81, 140, { fontSize: 9, maxWidth: 260 });
    drawText([client.address].filter(Boolean).join("   "), 81, 154, {
      fontSize: 9,
      maxWidth: 260,
    });
    drawText(advertisingType, 300, 187, { fontSize: 9, maxWidth: 330 });
  }

  function drawFooter(doc, drawText, tableStartY) {
    const TOTAL_Y = tableStartY + 19.3 * ROW_H_PX + 19;
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(20, 20, 20);
    const wordLines = doc.splitTextToSize(amountInWords || "", px(400));
    doc.text(wordLines[0] ?? "", px(40), py(TOTAL_Y + 18));
    if (selectedQuery?.contactPersonName) {
      drawText(selectedQuery.contactPersonName, 90, TOTAL_Y + 60, {
        fontSize: 9,
        color: [200, 0, 0],
        fontStyle: "bold",
        maxWidth: 200,
      });
    }
    if (selectedQuery?.phone) {
      drawText(selectedQuery.phone, 300, TOTAL_Y + 60, {
        fontSize: 8,
        color: [200, 0, 0],
        fontStyle: "bold",
        maxWidth: 200,
      });
    }
  }

  const docs = [];
  const firstBatch = mediaRateCardItems.slice(0, ROWS_PER_PAGE);
  const remaining = mediaRateCardItems.slice(ROWS_PER_PAGE);

  // ── Page 1 ──
  const doc1 = makeDoc();
  const drawText1 = makeDrawText(doc1);
  addBackground(doc1);
  drawHeader(drawText1);
  // ✅ pass serial number (idx + 1)
  firstBatch.forEach((item, idx) =>
    drawRow(drawText1, item, idx, TABLE_START_Y, idx + 1),
  );
  if (remaining.length === 0) {
    drawFooter(doc1, drawText1, TABLE_START_Y);
  }
  docs.push({
    doc: doc1,
    dataUrl: doc1.output("datauristring"),
    label: "Page 1",
  });

  // ── Continuation pages ──
  const chunks = [];
  for (let i = 0; i < remaining.length; i += ROWS_PER_PAGE) {
    chunks.push(remaining.slice(i, i + ROWS_PER_PAGE));
  }

  // ✅ track serial offset across pages
  let pageItemOffset = ROWS_PER_PAGE;

  chunks.forEach((batch, chunkIdx) => {
    const docN = makeDoc();
    const drawTextN = makeDrawText(docN);
    addBackground(docN);
    drawTextN(formatDate(date), 108, 78, { fontSize: 9 });
    drawTextN(quotationNumber, 556, 126, {
      fontSize: 10,
      align: "left",
      fontStyle: "bold",
      maxWidth: 120,
    });
    // ✅ pass correct serial number using offset
    batch.forEach((item, idx) =>
      drawRow(drawTextN, item, idx, TABLE_CONT_Y, pageItemOffset + idx + 1),
    );
    if (chunkIdx === chunks.length - 1) {
      drawFooter(docN, drawTextN, TABLE_CONT_Y);
    }
    // ✅ advance offset for next page
    pageItemOffset += batch.length;
    docs.push({
      doc: docN,
      dataUrl: docN.output("datauristring"),
      label: `Page ${chunkIdx + 2}`,
    });
  });

  return docs;
}

// ─── QuotationViewModalThree ───────────────────────────────────────────────────

export default function QuotationViewModalThree({
  open,
  quotationData,
  onClose,
  bgBase64,
}) {
  const [pages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [generating, setGenerating] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open || !quotationData || !bgBase64) return;
    setGenerating(true);
    try {
      const built = buildQuotationThreeDocs(quotationData, bgBase64);
      setPages(built);
      setCurrentPage(0);
    } catch (err) {
      console.error("QuotationViewModalThree build error:", err);
    } finally {
      setGenerating(false);
    }
  }, [open, quotationData, bgBase64]);

  const handleDownloadCurrent = useCallback(() => {
    if (!pages[currentPage]) return;
    const { doc } = pages[currentPage];
    const fname = `Quotation_${(
      quotationData?.quotationNumber || "draft"
    ).replace(/\//g, "-")}_p${currentPage + 1}.pdf`;
    doc.save(fname);
  }, [pages, currentPage, quotationData]);

  const handleDownloadAll = useCallback(() => {
    if (pages.length === 1) {
      handleDownloadCurrent();
      return;
    }
    pages.forEach(({ doc }, idx) => {
      const fname = `Quotation_${(
        quotationData?.quotationNumber || "draft"
      ).replace(/\//g, "-")}_p${idx + 1}.pdf`;
      doc.save(fname);
    });
  }, [pages, quotationData, handleDownloadCurrent]);

  const handleZoomIn = () => setZoom((z) => Math.min(z + 0.2, 2.5));
  const handleZoomOut = () => setZoom((z) => Math.max(z - 0.2, 0.3));

  if (!open) return null;

  const totalPages = pages.length;
  const current = pages[currentPage];
  const clientName =
    quotationData?.client?.bankName || quotationData?.client?.name || "—";
  const itemCount = quotationData?.mediaRateCardItems?.length || 0;

  return createPortal(
    <div
      className="fixed inset-0 z-50 flex flex-col"
      style={{ background: "rgba(8,15,35,0.95)" }}
    >
      {/* ── Top Bar ── */}
      <div
        className="flex items-center justify-between px-5 py-3 flex-shrink-0"
        style={{
          background: "linear-gradient(90deg,#0f1c3f 0%,#1a2f5e 100%)",
          borderBottom: "1px solid rgba(99,140,220,0.18)",
        }}
      >
        {/* Left: quotation info */}
        <div className="flex items-center gap-3 min-w-0">
          <div
            className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
            style={{
              background: "rgba(59,108,230,0.25)",
              border: "1px solid rgba(59,108,230,0.4)",
            }}
          >
            <RiFileTextLine
              style={{ width: 18, height: 18, color: "#93c5fd" }}
            />
          </div>
          <div className="min-w-0">
            <p className="text-xs font-bold text-blue-200 font-mono tracking-wider truncate flex items-center gap-1.5">
              <RiHashtag style={{ width: 11, height: 11 }} />
              {quotationData?.quotationNumber || "—"}
            </p>
            <p className="text-[10px] text-blue-400 truncate flex items-center gap-1.5">
              <span>{clientName}</span>
              {quotationData?.date && (
                <>
                  <span className="opacity-40">·</span>
                  <RiCalendarLine style={{ width: 10, height: 10 }} />
                  <span>{formatDate(quotationData.date)}</span>
                </>
              )}
              {itemCount > 0 && (
                <>
                  <span className="opacity-40">·</span>
                  <RiNewspaperLine style={{ width: 10, height: 10 }} />
                  <span>
                    {itemCount} item{itemCount !== 1 ? "s" : ""}
                  </span>
                </>
              )}
            </p>
          </div>
        </div>

        {/* Center: page navigation */}
        {totalPages > 1 && (
          <div className="flex items-center gap-2">
            <button
              onClick={() => setCurrentPage((p) => Math.max(0, p - 1))}
              disabled={currentPage === 0}
              className="w-8 h-8 rounded-lg flex items-center justify-center transition disabled:opacity-30"
              style={{
                background: "rgba(59,108,230,0.18)",
                border: "1px solid rgba(59,108,230,0.3)",
              }}
            >
              <RiArrowLeftSLine
                style={{ width: 16, height: 16, color: "#93c5fd" }}
              />
            </button>
            <span
              className="text-xs font-semibold text-blue-200 px-3 py-1 rounded-md"
              style={{ background: "rgba(59,108,230,0.15)" }}
            >
              Page {currentPage + 1} / {totalPages}
            </span>
            <button
              onClick={() =>
                setCurrentPage((p) => Math.min(totalPages - 1, p + 1))
              }
              disabled={currentPage === totalPages - 1}
              className="w-8 h-8 rounded-lg flex items-center justify-center transition disabled:opacity-30"
              style={{
                background: "rgba(59,108,230,0.18)",
                border: "1px solid rgba(59,108,230,0.3)",
              }}
            >
              <RiArrowRightSLine
                style={{ width: 16, height: 16, color: "#93c5fd" }}
              />
            </button>
          </div>
        )}

        {/* Right: zoom + download + close */}
        <div className="flex items-center gap-2 flex-shrink-0">
          {/* Zoom controls */}
          <div
            className="flex items-center gap-1 px-2 py-1 rounded-lg"
            style={{
              background: "rgba(59,108,230,0.12)",
              border: "1px solid rgba(59,108,230,0.22)",
            }}
          >
            <button
              onClick={handleZoomOut}
              title="Zoom Out"
              className="w-7 h-7 flex items-center justify-center rounded transition"
              style={{ color: "#93c5fd" }}
            >
              <RiZoomOutLine style={{ width: 15, height: 15 }} />
            </button>
            <span className="text-[11px] font-bold text-blue-200 w-10 text-center">
              {Math.round(zoom * 100)}%
            </span>
            <button
              onClick={handleZoomIn}
              title="Zoom In"
              className="w-7 h-7 flex items-center justify-center rounded transition"
              style={{ color: "#93c5fd" }}
            >
              <RiZoomInLine style={{ width: 15, height: 15 }} />
            </button>
          </div>

          {/* Download current page */}
          <button
            onClick={handleDownloadCurrent}
            disabled={generating || !current}
            className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-bold transition disabled:opacity-40"
            style={{
              background: "rgba(16,185,129,0.18)",
              border: "1px solid rgba(16,185,129,0.35)",
              color: "#6ee7b7",
            }}
          >
            <RiDownloadLine style={{ width: 14, height: 14 }} />
            {totalPages > 1 ? "This Page" : "Download"}
          </button>

          {/* Download all pages */}
          {totalPages > 1 && (
            <button
              onClick={handleDownloadAll}
              disabled={generating}
              className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-bold transition disabled:opacity-40"
              style={{
                background: "rgba(59,108,230,0.22)",
                border: "1px solid rgba(59,108,230,0.4)",
                color: "#93c5fd",
              }}
            >
              <RiDownloadLine style={{ width: 14, height: 14 }} />
              All ({totalPages})
            </button>
          )}

          {/* Close */}
          <button
            onClick={onClose}
            className="w-9 h-9 flex items-center justify-center rounded-lg transition"
            style={{
              background: "rgba(239,68,68,0.15)",
              border: "1px solid rgba(239,68,68,0.3)",
              color: "#fca5a5",
            }}
          >
            <RiCloseLine style={{ width: 18, height: 18 }} />
          </button>
        </div>
      </div>

      {/* ── Page tabs (multi-page only) ── */}
      {totalPages > 1 && !generating && (
        <div
          className="flex items-center gap-1 px-5 py-2 overflow-x-auto flex-shrink-0"
          style={{
            background: "rgba(15,28,63,0.85)",
            borderBottom: "1px solid rgba(59,108,230,0.12)",
          }}
        >
          {pages.map((p, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentPage(idx)}
              className="flex-shrink-0 px-3 py-1.5 rounded-md text-xs font-semibold transition whitespace-nowrap"
              style={
                currentPage === idx
                  ? {
                      background: "rgba(59,108,230,0.35)",
                      border: "1px solid rgba(59,108,230,0.55)",
                      color: "#bfdbfe",
                    }
                  : {
                      background: "rgba(59,108,230,0.08)",
                      border: "1px solid rgba(59,108,230,0.18)",
                      color: "#6b82a8",
                    }
              }
            >
              {p.label}
            </button>
          ))}
        </div>
      )}

      {/* ── PDF preview area ── */}
      <div
        ref={containerRef}
        className="flex-1 overflow-auto flex items-start justify-center"
        style={{
          background:
            "repeating-linear-gradient(45deg,#0b1427 0px,#0b1427 20px,#0c1630 20px,#0c1630 40px)",
          padding: "32px 24px",
        }}
      >
        {generating ? (
          <div className="flex flex-col items-center gap-4 mt-24">
            <AiOutlineLoading3Quarters
              className="animate-spin"
              style={{ width: 36, height: 36, color: "#60a5fa" }}
            />
            <p className="text-blue-300 text-sm font-medium">
              Building PDF preview…
            </p>
          </div>
        ) : !current ? (
          <div className="flex flex-col items-center gap-3 mt-24">
            <RiFileTextLine
              style={{ width: 48, height: 48, color: "#1e3a6e" }}
            />
            <p className="text-blue-400 text-sm">No content to preview.</p>
          </div>
        ) : (
          <div
            style={{
              transform: `scale(${zoom})`,
              transformOrigin: "top center",
              transition: "transform 0.2s ease",
              boxShadow:
                "0 8px 64px rgba(0,0,0,0.7), 0 2px 16px rgba(59,108,230,0.18)",
              borderRadius: 6,
              overflow: "hidden",
              lineHeight: 0,
            }}
          >
            <iframe
              key={current.dataUrl}
              src={current.dataUrl}
              title={`Quotation Preview - ${current.label}`}
              style={{
                width: 1300,
                height: 1075,
                border: "none",
                display: "block",
                background: "#fff",
              }}
            />
          </div>
        )}
      </div>

      {/* ── Footer status bar ── */}
      {!generating && current && (
        <div
          className="flex items-center justify-between px-5 py-2 flex-shrink-0 text-[11px]"
          style={{
            background: "rgba(10,18,40,0.95)",
            borderTop: "1px solid rgba(59,108,230,0.12)",
            color: "#4b6896",
          }}
        >
          <span>
            Client:{" "}
            <span className="text-blue-400 font-semibold">{clientName}</span>
            {quotationData?.advertisingType && (
              <>
                {" "}
                · Type:{" "}
                <span className="text-blue-400 font-semibold">
                  {quotationData.advertisingType}
                </span>
              </>
            )}
          </span>
          <span>
            Total:{" "}
            <span className="text-emerald-400 font-bold text-xs">
              ₹{fmt(quotationData?.totalAmount || 0)}
            </span>
          </span>
        </div>
      )}
    </div>,
    document.body,
  );
}
